export const APP_UPDATE_PROMPT_TRANSLATIONS = {
  softMessage: {
    "pt-BR": "Nova versão disponível",
    en: "A new version is available",
    es: "Hay una nueva versión disponible",
    de: "Eine neue Version ist verfügbar",
  },
  softReloadNow: {
    "pt-BR": "Atualizar agora",
    en: "Reload now",
    es: "Actualizar ahora",
    de: "Jetzt aktualisieren",
  },
  softLater: {
    "pt-BR": "Depois",
    en: "Later",
    es: "Después",
    de: "Später",
  },
  hardTitle: {
    "pt-BR": "Atualização do produto em andamento",
    en: "Product update in progress",
    es: "Actualización del producto en curso",
    de: "Produktaktualisierung läuft",
  },
  hardBody: {
    "pt-BR": "Estamos carregando a nova versão. Isso leva só um momento.",
    en: "We are loading the new version. This only takes a moment.",
    es: "Estamos cargando la nueva versión. Solo tomará un momento.",
    de: "Wir laden die neue Version. Das dauert nur einen Moment.",
  },
  unsavedLossWarning: {
    "pt-BR": "Alterações não salvas podem ser perdidas.",
    en: "Unsaved changes may be lost.",
    es: "Los cambios no guardados pueden perderse.",
    de: "Nicht gespeicherte Änderungen können verloren gehen.",
  },
  hardReload: {
    "pt-BR": "Recarregar",
    en: "Reload",
    es: "Recargar",
    de: "Neu laden",
  },
} as const;

/** Admin chrome may stay pt-BR-only (BR-14). */
export const APP_UPDATE_PROMPT_ADMIN_PT = {
  softMessage: "Nova versão disponível",
  softReloadNow: "Atualizar agora",
  softLater: "Depois",
  hardTitle: "Atualização do produto em andamento",
  hardBody: "Estamos carregando a nova versão. Isso leva só um momento.",
  unsavedLossWarning: "Alterações não salvas podem ser perdidas.",
  hardReload: "Recarregar",
} as const;
